import { render, staticRenderFns } from "./TimeLine.vue?vue&type=template&id=67147aed&scoped=true&"
import script from "./TimeLine.vue?vue&type=script&lang=js&"
export * from "./TimeLine.vue?vue&type=script&lang=js&"
import style0 from "./TimeLine.vue?vue&type=style&index=0&id=67147aed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67147aed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VIcon,VImg,VTimeline,VTimelineItem})
